/**
 *
 * Copyright 2020-2025 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { diag } from '@opentelemetry/api';
export class Observable {
    observers = [];
    notify(data) {
        this.observers.forEach((observer) => {
            try {
                observer(data);
            }
            catch (error) {
                diag.error('Observable: Error happened in subscriber', error);
            }
        });
    }
    subscribe(f) {
        this.observers.push(f);
        return () => {
            const index = this.observers.indexOf(f);
            if (index !== -1) {
                this.observers.splice(index, 1);
            }
        };
    }
}
//# sourceMappingURL=observable.js.map